



















































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

import PollForm from 'shared/components/PollForm.vue';

import { ChannelSettings, Poll, PollState } from 'shared/js/store/poll';

@Component({
  components: { PollForm },
  computed: mapState('polls', ['settings'])
})
export default class App extends Vue {
  public get accentColor(): string {
    return this.settings.accentColor;
  }

  public get textColor(): string {
    return this.settings.textColor;
  }

  public get poll(): Poll | null {
    return this.settings.poll;
  }

  public get pollIsReady(): boolean {
    if (!this.poll) {
      return false;
    }

    return this.poll.state >= PollState.VotingOpen && this.poll.state < PollState.Over;
  }

  public loading: boolean = true;
  public error: string | null = null;
  public sdk: any = null;

  public showApp: boolean = false;
  public controlsVisible: boolean = true;

  public settings!: ChannelSettings;
  public PollState: any = PollState;

  public created() {
    this.sdk = new this.$muxy.SDK();
    this.sdk
      .loaded()
      .then(() => this.sdk.getAllState())
      .then(state => {
        if (state.channel) {
          this.$store.commit('polls/setChannelState', state.channel);
        }

        this.sdk.listen('poll-start', poll => {
          // If we are currently showing the app, we wait 1 second
          // for the app to hide before setting the poll and showing it.
          let timeout = 0;
          if (this.showApp) {
            timeout = 1000;
          }
          this.showApp = false;

          setTimeout(() => {
            this.$store.commit('polls/clearViewerVote');
            this.$store.commit('polls/setPoll', poll);
            this.showApp = true;
          }, timeout);
        });

        this.sdk.listen('poll-close', poll => {
          this.$store.commit('polls/setPoll', poll);
          this.showApp = true;
        });

        this.sdk.listen('poll-end', poll => {
          this.showApp = false;
          this.$store.commit('polls/setPoll', poll);
        });

        this.sdk.listen('settings-changed', settings => {
          this.$store.commit('polls/setAccentColor', settings.accentColor);
          this.$store.commit('polls/setTextColor', settings.textColor);
        });

        if (this.poll) {
          this.sdk.getVoteData(this.poll.id).then(data => {
            if (data.vote !== undefined) {
              this.$store.commit('polls/setViewerVote', data.vote);
            } else if (this.poll && this.poll.state === PollState.VotingOpen) {
              this.showApp = true;
            }
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      })
      .then(() => {
        this.loading = false;
      });

    document.addEventListener('click', this.hideExtensionOnDocumentClick);
  }

  public destroyed() {
    document.removeEventListener('click', this.hideExtensionOnDocumentClick);
  }

  public mounted() {
    window.Twitch.ext.onContext(({ arePlayerControlsVisible }) => {
      this.controlsVisible = arePlayerControlsVisible;
    });
  }

  public toggleExtVisibility(showExt?: boolean) {
    this.showApp = typeof(showExt) === typeof(true) ? !!showExt : !this.showApp;
  }

  public hideExtensionOnDocumentClick(evt: MouseEvent) {
    if (evt.target === this.$el) {
      this.toggleExtVisibility(false);
    }
  }
}
